// A list keeps the order the person sees while they work on it: a row that a save moves (a rule set,
// no longer "needs a rule", a customer that becomes a group; on the Worklist and History a line whose
// window state a Routing status changes) stays where it was until the person changes a filter or the
// sort, or reloads. `seen` is the order of the last view; rows not in it (new) come after, in their own
// order; a row no longer there just goes. No imports: `scripts/routing-checks.ts` checks it.

export function keepOrder<T>(rows: readonly T[], key: (r: T) => string, seen: readonly string[]): T[] {
  const at = new Map(seen.map((k, i) => [k, i]));
  return rows
    .map((r, i) => ({ r, i, at: at.get(key(r)) }))
    .sort((a, b) => (a.at ?? seen.length + a.i) - (b.at ?? seen.length + b.i))
    .map((x) => x.r);
}

/** The last view: the filters it was shown with and its order. */
export interface SeenOrder<F> {
  filters: F;
  order: string[];
}

/** The rows in the order the person saw under the same filters (the same object); other filters: their own order. */
export const shownOrder = <T, F>(
  rows: readonly T[],
  key: (r: T) => string,
  filters: F,
  seen: SeenOrder<F> | null,
): T[] => (seen && seen.filters === filters ? keepOrder(rows, key, seen.order) : [...rows]);
